export const CampaignFile = (builder) => ({
  CampaignFile: builder.mutation({
    query: ({ b_party_details }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/check_duplicacy",
        method: "GET",
        params: { b_party_details },
        headers: {
          Authorization: token,
        },
      };
    },
  }),
});
